/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ResumeRequestBuilderRequestsMetadata, type ResumeRequestBuilder } from './resume/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/pending/{fileId}/revisions/{revisionId}
 */
export interface WithRevisionItemRequestBuilder extends BaseRequestBuilder<WithRevisionItemRequestBuilder> {
    /**
     * The resume property
     */
    get resume(): ResumeRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithRevisionItemRequestBuilderUriTemplate = "{+baseurl}/files/pending/{fileId}/revisions/{revisionId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithRevisionItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithRevisionItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    resume: {
        requestsMetadata: ResumeRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
